export default __webpack_public_path__ + "static/abba-2b1d4e1fe762da5ff097b03dd220b407.jpg";